<template>
  <div
    class="
      is-align-items-center
      is-flex
      is-flex-direction-column
      is-justify-content-center
      mb-large
    "
  >
    <div class="mb-9">
      <h1 class="has-text-black has-text-weight-light is-size-3 mb-4">
        關於您的組織
      </h1>
      <p class="has-text-centered">
        簡單填寫相關資訊
      </p>
    </div>
    <form class="second-step__fields px-5" onsubmit="return false">
      <b-field
        custom-class="has-text-black has-text-left is-align-self-center is-flex-grow-2"
        grouped
        horizontal
        label="選擇組織類型"
      >
        <div class="full-height is-align-items-center is-flex second-step__organization-types">
          <b-radio
            v-model="organizationType"
            v-for="type in organizationTypes"
            :key="`organization-type-${type.value}`"
            :native-value="type.value"
            class="second-step__organization-types--type"
          >
            {{ type.text }}
          </b-radio>
        </div>
      </b-field>
      <b-field
        :message="getErrorMsgs('name')"
        :type="{ 'is-danger': hasErrorMsgs('name') }"
      >
        <b-input
          :use-html5-validation="false"
          placeholder="請輸入公司/組織名稱"
          v-model="v$.form.name.$model"
        />
      </b-field>
      <b-field
        :message="getErrorMsgs('scale')"
        :type="{ 'is-danger': hasErrorMsgs('scale') }"
      >
        <b-select
          v-model="v$.form.scale.$model"
          expanded
          placeholder="請選擇組織規模人數"
        >
          <option
            v-for="scale in scales"
            :key="`organization-scale-${scale.value}`"
            :value="scale.value"
          >
            {{ scale.text }}
          </option>
        </b-select>
      </b-field>
      <b-button
        :disabled="v$.form.$invalid && v$.form.$dirty"
        :loading="registering"
        class="mt-large"
        expanded
        type="is-primary"
        @click="register"
      >
        註冊
      </b-button>
      <p class="has-text-black mt-4 second-step__agreement">
        點擊註冊即表示您同意「好彙訂」
        <a
          alt="Term of Service"
          class="second-step__link"
          href="https://www.takeorder.tw/terms-of-service"
          target="_blank"
        >
          使用條款
        </a>
        及
        <a
          alt="Privacy and Policy"
          class="second-step__link"
          href="https://www.takeorder.tw/privacy-and-policy"
          target="_blank"
        >
          隱私權政策
        </a>
      </p>
    </form>
  </div>
</template>

<script>
import SecondStep from './SecondStep';

export default SecondStep;
</script>

<style lang="scss" scoped>
@import 'SecondStep';
</style>
